import * as types from 'src/state/ducks/notification/types';
import { BakedBreadEntity } from 'src/firebase/db/BakedBreads';
import { OrderBreadEntity } from 'src/firebase/db/OrderBreads';
import { NotificationEntity, NotificationProps } from 'src/firebase/db/Notifications';
import { APISuccessfulResponse, APIFailedResponse } from 'src/firebase/db/DatabaseAdapter';
import { ValidationResponse } from 'src/firebase/db/ValidationManager';

export type Actions =
  | GetNotifications
  | SuccessGetNotifications
  | FailGetNotifications
  | HasNotifications
  | SuccessHasNotifications
  | FailHasNotifications
  | GetReservations
  | SuccessGetReservations
  | FailGetReservations
  | GetReservation
  | SuccessGetReservation
  | FailGetReservation
  | GetDayReservation
  | SuccessGetDayReservation
  | FailGetDayReservation
  | GetDayNotifications
  | SuccessGetDayNotifications
  | FailGetDayNotifications
  | GetTemplatesNotifications
  | SuccessGetTemplatesNotifications
  | FailGetTemplatesNotifications
  | InitNotification
  | EditNotification
  | InitReservation
  | EditReservation
  | CancelReservation
  | SuccessCancelReservation
  | FailCancelReservation
  | ValidateNotification
  | SuccessValidateNotification
  | FailValidateNotification
  | CreateNotification
  | SuccessCreateNotification
  | FailCreateNotification
  | CreateNotifications
  | SuccessCreateNotifications
  | FailCreateNotifications
  | CreateReservation
  | SuccessCreateReservation
  | FailCreateReservation
  | UpdateReservation
  | SuccessUpdateReservation
  | FailUpdateReservation
  | DeleteReservation
  | SuccessDeleteReservation
  | FailDeleteReservation
  | DuplicateReservations
  | SuccessDuplicateReservations
  | FailDuplicateReservations
  | ValidateReservation
  | SuccessValidateReservation
  | FailValidateReservation
  | RemoveOrderBreadFromNotification
  | SuccessRemoveOrderBreadFromNotification
  | FailRemoveOrderBreadFromNotification
  | CompleteRemoveOrderBreadFromNotification;

/**
 * Get
 */
interface GetNotifications {
  type: typeof types.GET_NOTIFICATIONS;
  payload: {
    shopId: string;
  };
}
export const getNotifications = (payload: GetNotifications['payload']) => ({
  type: types.GET_NOTIFICATIONS,
  payload,
});

interface SuccessGetNotifications {
  type: typeof types.SUCCESS_GET_NOTIFICATIONS;
  payload: APISuccessfulResponse<NotificationEntity[]>;
}
export const successGetNotifications = (payload: SuccessGetNotifications['payload']) => ({
  type: types.SUCCESS_GET_NOTIFICATIONS,
  payload,
});

interface FailGetNotifications {
  type: typeof types.FAIL_GET_NOTIFICATIONS;
  payload: ValidationResponse | APIFailedResponse;
}
export const failGetNotifications = (payload: FailGetNotifications['payload']) => ({
  type: types.FAIL_GET_NOTIFICATIONS,
  payload,
});

/**
 * Check a shop has notified somethings
 */
interface HasNotifications {
  type: typeof types.HAS_NOTIFICATIONS;
  payload: {
    shopId: string;
  };
}
export const hasNotifications = (payload: HasNotifications['payload']) => ({
  type: types.HAS_NOTIFICATIONS,
  payload,
});

interface SuccessHasNotifications {
  type: typeof types.SUCCESS_HAS_NOTIFICATIONS;
  payload: APISuccessfulResponse<boolean>;
}
export const successHasNotifications = (payload: SuccessHasNotifications['payload']) => ({
  type: types.SUCCESS_HAS_NOTIFICATIONS,
  payload,
});

interface FailHasNotifications {
  type: typeof types.FAIL_HAS_NOTIFICATIONS;
  payload: ValidationResponse | APIFailedResponse;
}
export const failHasNotifications = (payload: FailHasNotifications['payload']) => ({
  type: types.FAIL_HAS_NOTIFICATIONS,
  payload,
});

/**
 * Get (Reservation)
 */
interface GetReservation {
  type: typeof types.GET_RESERVATION;
  payload: {
    id: string;
  };
}
export const getReservation = (payload: GetReservation['payload']) => ({
  type: types.GET_RESERVATION,
  payload,
});

interface SuccessGetReservation {
  type: typeof types.SUCCESS_GET_RESERVATION;
  payload: APISuccessfulResponse<{
    bakedBread: BakedBreadEntity;
    orderBread: OrderBreadEntity;
    notification: NotificationEntity;
  }>;
}
export const successGetReservation = (payload: SuccessGetReservation['payload']) => ({
  type: types.SUCCESS_GET_RESERVATION,
  payload,
});

interface FailGetReservation {
  type: typeof types.FAIL_GET_RESERVATION;
  payload: ValidationResponse | APIFailedResponse;
}
export const failGetReservation = (payload: FailGetReservation['payload']) => ({
  type: types.FAIL_GET_RESERVATION,
  payload,
});

/**
 * Get (Reservations)
 */
interface GetReservations {
  type: typeof types.GET_RESERVATIONS;
  payload: {
    shopId: string;
    isNotified?: boolean;
  };
}
export const getReservations = (payload: GetReservations['payload']) => ({
  type: types.GET_RESERVATIONS,
  payload,
});

interface SuccessGetReservations {
  type: typeof types.SUCCESS_GET_RESERVATIONS;
  payload: APISuccessfulResponse<NotificationEntity[]>;
}
export const successGetReservations = (payload: SuccessGetReservations['payload']) => ({
  type: types.SUCCESS_GET_RESERVATIONS,
  payload,
});

interface FailGetReservations {
  type: typeof types.FAIL_GET_RESERVATIONS;
  payload: ValidationResponse | APIFailedResponse;
}
export const failGetReservations = (payload: FailGetReservations['payload']) => ({
  type: types.FAIL_GET_RESERVATIONS,
  payload,
});

/**
 * Init
 */
interface InitNotification {
  type: typeof types.INIT_NOTIFICATION;
}
export const initNotification = () => ({
  type: types.INIT_NOTIFICATION,
});

/**
 * ReEdit
 */
interface EditNotification {
  type: typeof types.EDIT_NOTIFICATION;
  payload: NotificationEntity;
}
export const editNotification = (payload: ValidateNotification['payload']) => ({
  type: types.EDIT_NOTIFICATION,
  payload,
});

/**
 * Init (Reservation)
 */
interface InitReservation {
  type: typeof types.INIT_RESERVATION;
}
export const initReservation = () => ({
  type: types.INIT_RESERVATION,
});

/**
 * ReEdit (Reservation)
 */
interface EditReservation {
  type: typeof types.EDIT_RESERVATION;
}
export const editReservation = () => ({
  type: types.EDIT_RESERVATION,
});

/**
 * Cancel (Reservation)
 */
interface CancelReservation {
  type: typeof types.CANCEL_RESERVATION;
  payload: {
    id: string;
  };
}
export const cancelReservation = (payload: CancelReservation['payload']) => ({
  type: types.CANCEL_RESERVATION,
  payload,
});

interface SuccessCancelReservation {
  type: typeof types.SUCCESS_CANCEL_RESERVATION;
  payload: APISuccessfulResponse<NotificationEntity>;
}
export const successCancelReservation = (payload: SuccessCancelReservation['payload']) => ({
  type: types.SUCCESS_CANCEL_RESERVATION,
  payload,
});

interface FailCancelReservation {
  type: typeof types.FAIL_CANCEL_RESERVATION;
  payload: ValidationResponse | APIFailedResponse;
}
export const failCancelReservation = (payload: FailCancelReservation['payload']) => ({
  type: types.FAIL_CANCEL_RESERVATION,
  payload,
});

/**
 * Validate
 */
interface ValidateNotification {
  type: typeof types.VALIDATE_NOTIFICATION;
  payload: NotificationEntity;
}
export const validateNotification = (payload: ValidateNotification['payload']) => ({
  type: types.VALIDATE_NOTIFICATION,
  payload,
});

interface SuccessValidateNotification {
  type: typeof types.SUCCESS_VALIDATE_NOTIFICATION;
  payload: APISuccessfulResponse<NotificationEntity>;
}
export const successValidateNotification = (payload: SuccessValidateNotification['payload']) => ({
  type: types.SUCCESS_VALIDATE_NOTIFICATION,
  payload,
});

interface FailValidateNotification {
  type: typeof types.FAIL_VALIDATE_NOTIFICATION;
  payload: ValidationResponse | APIFailedResponse;
}
export const failValidateNotification = (payload: FailValidateNotification['payload']) => ({
  type: types.FAIL_VALIDATE_NOTIFICATION,
  payload,
});

/**
 * Create
 */
interface CreateNotification {
  type: typeof types.CREATE_NOTIFICATION;
  payload: NotificationEntity;
}
export const createNotification = (payload: CreateNotification['payload']) => ({
  type: types.CREATE_NOTIFICATION,
  payload,
});

interface SuccessCreateNotification {
  type: typeof types.SUCCESS_CREATE_NOTIFICATION;
  payload: APISuccessfulResponse<NotificationEntity>;
}
export const successCreateNotification = (payload: SuccessCreateNotification['payload']) => ({
  type: types.SUCCESS_CREATE_NOTIFICATION,
  payload,
});

interface FailCreateNotification {
  type: typeof types.FAIL_CREATE_NOTIFICATION;
  payload: ValidationResponse | APIFailedResponse;
}
export const failCreateNotification = (payload: FailCreateNotification['payload']) => ({
  type: types.FAIL_CREATE_NOTIFICATION,
  payload,
});

/**
 * Create (multiple)
 */
interface CreateNotifications {
  type: typeof types.CREATE_NOTIFICATIONS;
  payload: NotificationEntity[];
}
export const createNotifications = (payload: CreateNotifications['payload']) => ({
  type: types.CREATE_NOTIFICATIONS,
  payload,
});

interface SuccessCreateNotifications {
  type: typeof types.SUCCESS_CREATE_NOTIFICATIONS;
  payload: APISuccessfulResponse<NotificationEntity[]>;
}
export const successCreateNotifications = (payload: SuccessCreateNotifications['payload']) => ({
  type: types.SUCCESS_CREATE_NOTIFICATION,
  payload,
});

interface FailCreateNotifications {
  type: typeof types.FAIL_CREATE_NOTIFICATIONS;
  payload: ValidationResponse | APIFailedResponse;
}
export const failCreateNotifications = (payload: FailCreateNotifications['payload']) => ({
  type: types.FAIL_CREATE_NOTIFICATIONS,
  payload,
});

/**
 * Create (Reservation)
 */
interface CreateReservation {
  type: typeof types.CREATE_RESERVATION;
  payload: {
    bakedBread: BakedBreadEntity;
    orderBread: OrderBreadEntity;
    notification: NotificationEntity;
  };
}
export const createReservation = (payload: CreateReservation['payload']) => ({
  type: types.CREATE_RESERVATION,
  payload,
});

interface SuccessCreateReservation {
  type: typeof types.SUCCESS_CREATE_RESERVATION;
  payload: APISuccessfulResponse<NotificationEntity>;
}
export const successCreateReservation = (payload: SuccessCreateReservation['payload']) => ({
  type: types.SUCCESS_CREATE_RESERVATION,
  payload,
});

interface FailCreateReservation {
  type: typeof types.FAIL_CREATE_RESERVATION;
  payload: ValidationResponse | APIFailedResponse;
}
export const failCreateReservation = (payload: FailCreateReservation['payload']) => ({
  type: types.FAIL_CREATE_RESERVATION,
  payload,
});

/**
 * Update (Reservation)
 */
interface UpdateReservation {
  type: typeof types.UPDATE_RESERVATION;
  payload: {
    bakedBread: BakedBreadEntity;
    orderBread: OrderBreadEntity;
    notification: NotificationEntity;
  };
}
export const updateReservation = (payload: UpdateReservation['payload']) => ({
  type: types.UPDATE_RESERVATION,
  payload,
});

interface SuccessUpdateReservation {
  type: typeof types.SUCCESS_UPDATE_RESERVATION;
  payload: APISuccessfulResponse<NotificationEntity>;
}
export const successUpdateReservation = (payload: SuccessUpdateReservation['payload']) => ({
  type: types.SUCCESS_UPDATE_RESERVATION,
  payload,
});

interface FailUpdateReservation {
  type: typeof types.FAIL_UPDATE_RESERVATION;
  payload: ValidationResponse | APIFailedResponse;
}
export const failUpdateReservation = (payload: FailUpdateReservation['payload']) => ({
  type: types.FAIL_UPDATE_RESERVATION,
  payload,
});

/**
 * Delete (Reservation)
 */
interface DeleteReservation {
  type: typeof types.DELETE_RESERVATION;
  payload: string;
}
export const deleteReservation = (payload: DeleteReservation['payload']) => ({
  type: types.DELETE_RESERVATION,
  payload,
});

interface SuccessDeleteReservation {
  type: typeof types.SUCCESS_DELETE_RESERVATION;
  payload: APISuccessfulResponse<NotificationEntity>;
}
export const successDeleteReservation = (payload: SuccessDeleteReservation['payload']) => ({
  type: types.SUCCESS_DELETE_RESERVATION,
  payload,
});

interface FailDeleteReservation {
  type: typeof types.FAIL_DELETE_RESERVATION;
  payload: ValidationResponse | APIFailedResponse;
}
export const failDeleteReservation = (payload: FailDeleteReservation['payload']) => ({
  type: types.FAIL_DELETE_RESERVATION,
  payload,
});

/**
 * Duplicate (Reservations)
 */
interface DuplicateReservations {
  type: typeof types.DUPLICATE_RESERVATIONS;
  payload: string[];
}
export const duplicateReservations = (payload: DuplicateReservations['payload']) => ({
  type: types.DUPLICATE_RESERVATIONS,
  payload,
});

interface SuccessDuplicateReservations {
  type: typeof types.SUCCESS_DUPLICATE_RESERVATIONS;
  payload: APISuccessfulResponse<NotificationEntity>;
}
export const successDuplicateReservations = (payload: SuccessDuplicateReservations['payload']) => ({
  type: types.SUCCESS_DUPLICATE_RESERVATIONS,
  payload,
});

interface FailDuplicateReservations {
  type: typeof types.FAIL_DUPLICATE_RESERVATIONS;
  payload: ValidationResponse | APIFailedResponse;
}
export const failDuplicateReservations = (payload: FailDuplicateReservations['payload']) => ({
  type: types.FAIL_DUPLICATE_RESERVATIONS,
  payload,
});


/**
 * Validate (Reservation)
 */
interface ValidateReservation {
  type: typeof types.VALIDATE_RESERVATION;
  payload: {
    bakedBread: BakedBreadEntity;
    orderBread: OrderBreadEntity;
    notification: NotificationEntity;
  };
}
export const validateReservation = (payload: ValidateReservation['payload']) => ({
  type: types.VALIDATE_RESERVATION,
  payload,
});

interface SuccessValidateReservation {
  type: typeof types.SUCCESS_VALIDATE_RESERVATION;
  payload: APISuccessfulResponse<{
    bakedBread: BakedBreadEntity;
    orderBread: OrderBreadEntity;
    notification: NotificationEntity;
  }>;
}
export const successValidateReservation = (payload: SuccessValidateReservation['payload']) => ({
  type: types.SUCCESS_VALIDATE_RESERVATION,
  payload,
});

interface FailValidateReservation {
  type: typeof types.FAIL_VALIDATE_RESERVATION;
  payload: ValidationResponse | APIFailedResponse;
}
export const failValidateReservation = (payload: FailValidateReservation['payload']) => ({
  type: types.FAIL_VALIDATE_RESERVATION,
  payload,
});

/**
 * Remove order_breads ref
 */
interface RemoveOrderBreadFromNotification {
  type: typeof types.REMOVE_ORDER_BREAD_FROM_NOTIFICATION;
  payload: string;
}
export const removeOrderBreadFromNotification = (
  payload: RemoveOrderBreadFromNotification['payload'],
) => ({
  type: types.REMOVE_ORDER_BREAD_FROM_NOTIFICATION,
  payload,
});

interface SuccessRemoveOrderBreadFromNotification {
  type: typeof types.SUCCESS_REMOVE_ORDER_BREAD_FROM_NOTIFICATION;
  payload: APISuccessfulResponse<NotificationEntity>;
}
export const successRemoveOrderBreadFromNotification = (
  payload: SuccessRemoveOrderBreadFromNotification['payload'],
) => ({
  type: types.SUCCESS_REMOVE_ORDER_BREAD_FROM_NOTIFICATION,
  payload,
});

interface FailRemoveOrderBreadFromNotification {
  type: typeof types.FAIL_REMOVE_ORDER_BREAD_FROM_NOTIFICATION;
  payload: ValidationResponse | APIFailedResponse;
}
export const failRemoveOrderBreadFromNotification = (
  payload: FailRemoveOrderBreadFromNotification['payload'],
) => ({
  type: types.FAIL_REMOVE_ORDER_BREAD_FROM_NOTIFICATION,
  payload,
});

interface CompleteRemoveOrderBreadFromNotification {
  type: typeof types.COMPLETE_REMOVE_ORDER_BREAD_FROM_NOTIFICATION;
}
export const completeRemoveOrderBreadFromNotification = () => ({
  type: types.COMPLETE_REMOVE_ORDER_BREAD_FROM_NOTIFICATION,
});

/**
 * Get a notification by date
 */
interface GetDayReservation {
  type: typeof types.GET_DAY_RESERVATION;
  payload: {
    id: string;
    shopId?: string;
    isAdmin?: boolean;
  };
}
export const getDayReservation = (payload: GetDayReservation['payload']) => ({
  type: types.GET_DAY_RESERVATION,
  payload,
});

interface SuccessGetDayReservation {
  type: typeof types.SUCCESS_GET_DAY_RESERVATION;
  payload: APISuccessfulResponse<NotificationProps>;
}
export const successGetDayReservation = (payload: SuccessGetDayReservation['payload']) => ({
  type: types.SUCCESS_GET_DAY_RESERVATION,
  payload,
});

interface FailGetDayReservation {
  type: typeof types.FAIL_GET_DAY_RESERVATION;
  payload: ValidationResponse | APIFailedResponse;
}
export const failGetDayReservation = (payload: FailGetDayReservation['payload']) => ({
  type: types.FAIL_GET_DAY_RESERVATION,
  payload,
});

/**
 * Get notifications by date
 */
interface GetDayNotifications {
  type: typeof types.GET_DAY_NOTIFICATIONS;
  payload: {
    shopId: string;
    startDate: Date;
    endDate: Date;
    isReservation: boolean;
    noDetails?: boolean;
  };
}
export const getDayNotifications = (payload: GetDayNotifications['payload']) => ({
  type: types.GET_DAY_NOTIFICATIONS,
  payload,
});

interface SuccessGetDayNotifications {
  type: typeof types.SUCCESS_GET_DAY_NOTIFICATIONS;
  payload: APISuccessfulResponse<NotificationProps[]>;
}
export const successGetDayNotifications = (payload: SuccessGetDayNotifications['payload']) => ({
  type: types.SUCCESS_GET_DAY_NOTIFICATIONS,
  payload,
});

interface FailGetDayNotifications {
  type: typeof types.FAIL_GET_DAY_NOTIFICATIONS;
  payload: ValidationResponse | APIFailedResponse;
}
export const failGetDayNotifications = (payload: FailGetDayNotifications['payload']) => ({
  type: types.FAIL_GET_DAY_NOTIFICATIONS,
  payload,
});

/**
 * Parse templates as entities of notification
 */
interface GetTemplatesNotifications {
  type: typeof types.GET_TEMPLATES_NOTIFICATIONS;
  payload: string[];
}
export const getTemplatesNotifications = (payload: GetTemplatesNotifications['payload']) => ({
  type: types.GET_TEMPLATES_NOTIFICATIONS,
  payload,
});

interface SuccessGetTemplatesNotifications {
  type: typeof types.SUCCESS_GET_TEMPLATES_NOTIFICATIONS;
  payload: APISuccessfulResponse<NotificationEntity[]>;
}
export const successGetTemplatesNotifications = (
  payload: SuccessGetTemplatesNotifications['payload'],
) => ({
  type: types.SUCCESS_GET_TEMPLATES_NOTIFICATIONS,
  payload,
});

interface FailGetTemplatesNotifications {
  type: typeof types.FAIL_GET_TEMPLATES_NOTIFICATIONS;
  payload: ValidationResponse | APIFailedResponse;
}
export const failGetTemplatesNotifications = (payload: FailGetDayNotifications['payload']) => ({
  type: types.FAIL_GET_TEMPLATES_NOTIFICATIONS,
  payload,
});
